/* Mega Metals — product single page behaviour
 * (variant/price, quantity stepper, gallery, tabs, per-store stock, store label).
 */
(function () {
  var root = document.querySelector('[data-mm-pdp]');
  if (!root) return;

  /* ---- Quantity stepper ---- */
  var qtyInput = root.querySelector('[data-qty-input]');
  var minus = root.querySelector('[data-qty-minus]');
  var plus = root.querySelector('[data-qty-plus]');
  if (qtyInput && minus && plus) {
    minus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    plus.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });
  }

  /* ---- Variant select → price ---- */
  var variantSelect = root.querySelector('[data-variant-select]');
  var priceEl = root.querySelector('[data-price-amount]');
  var addBtn = root.querySelector('[data-add-btn]');

  /* ---- Per-store stock (real data via variant metafields, mirrored by Shopify Flow) ---- */
  var stockDataEl = root.querySelector('[data-mm-stock-data]');
  var stockData = {};
  if (stockDataEl) {
    try { stockData = JSON.parse(stockDataEl.textContent); } catch (e) { stockData = {}; }
  }
  var stockRows = root.querySelectorAll('[data-location-key]');
  var oosMsg = root.querySelector('[data-stock-oos-msg]');
  var isAccessory = root.dataset.mmIsAccessory === 'true';

  function getSelectedVariantId() {
    if (variantSelect) return variantSelect.value;
    var hiddenInput = root.querySelector('input[name="id"]');
    return hiddenInput ? hiddenInput.value : null;
  }

  function getSelectedStoreKey() {
    var stored = window.localStorage.getItem('mm_store');
    return (stored || root.dataset.mmDefaultStore || 'Sydney').trim().toLowerCase();
  }

  function variantIsAvailable() {
    if (variantSelect) {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      return opt ? opt.dataset.available === 'true' : true;
    }
    return addBtn ? addBtn.dataset.variantAvailable === 'true' : true;
  }

  function renderStock() {
    var variantId = getSelectedVariantId();
    var stock = stockData[variantId] || { sydney: 0, melbourne: 0 };
    // "Continue selling when out of stock" / untracked inventory overrides the
    // metafield mirror — always purchasable, both locations shown In Stock.
    var alwaysAvailable = !!stock.alwaysAvailable;
    var anyStock = alwaysAvailable || (stock.sydney || 0) > 0 || (stock.melbourne || 0) > 0;

    stockRows.forEach(function (row) {
      var key = row.getAttribute('data-location-key');
      var qty = stock[key] || 0;
      var badge = row.querySelector('[data-stock-badge]');
      if (!badge) return;
      var inStock = alwaysAvailable || (isAccessory ? anyStock : qty > 0);
      badge.classList.remove('is-in', 'is-out');
      badge.classList.add(inStock ? 'is-in' : 'is-out');
      badge.innerHTML = '<span class="dot"></span>' + (inStock ? 'In Stock' : 'Out of Stock');
    });

    var storeKey = getSelectedStoreKey();
    var selectedQty = stock[storeKey] || 0;
    var available = variantIsAvailable();
    var selectedInStock = alwaysAvailable || (isAccessory ? anyStock : selectedQty > 0);
    var canAdd = available && selectedInStock;

    var selBadge = root.querySelector('[data-stock-selected-badge]');
    if (selBadge) {
      selBadge.classList.remove('is-in', 'is-out');
      selBadge.classList.add(selectedInStock ? 'is-in' : 'is-out');
      selBadge.innerHTML = '<span class="dot"></span>' + (selectedInStock ? 'In Stock' : 'Out of Stock');
    }

    if (addBtn) {
      addBtn.disabled = !canAdd;
      var labelEl = addBtn.querySelector('[data-add-btn-label]');
      if (labelEl) labelEl.textContent = canAdd ? 'Add to Cart' : (available ? 'Out of stock' : 'Sold out');
    }
    if (oosMsg) {
      oosMsg.hidden = canAdd;
      if (!canAdd) {
        oosMsg.textContent = (!isAccessory && anyStock) ? oosMsg.dataset.msgFreight : oosMsg.dataset.msgAllOut;
      }
    }
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      renderStock();
    });
  }

  if (stockRows.length || addBtn) {
    renderStock();
    window.addEventListener('mm:storechange', renderStock);
  }

  /* ---- Stock dropdown (both stores) ---- */
  var stockToggle = root.querySelector('[data-stock-toggle]');
  var stockPanel = root.querySelector('[data-stock-rows]');
  if (stockToggle && stockPanel) {
    stockToggle.addEventListener('click', function () {
      var open = stockPanel.hidden;
      stockPanel.hidden = !open;
      stockToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      stockToggle.classList.toggle('is-open', open);
    });
  }

  /* ---- Gallery thumbnails ---- */
  var mainImg = root.querySelector('[data-gallery-main] img');
  root.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full');
      if (mainImg && src) mainImg.src = src;
      root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---- Image lightbox (click main image to enlarge) ---- */
  var lightbox = root.querySelector('[data-lightbox]');
  var mainBtn = root.querySelector('[data-lightbox-open]');
  if (lightbox && mainBtn && mainImg) {
    var lightboxImg = lightbox.querySelector('[data-lightbox-img]');
    var openLightbox = function () {
      lightboxImg.src = mainImg.currentSrc || mainImg.src;
      lightboxImg.alt = mainImg.alt || '';
      lightbox.hidden = false;
      document.documentElement.classList.add('mm-modal-open');
    };
    var closeLightbox = function () {
      lightbox.hidden = true;
      document.documentElement.classList.remove('mm-modal-open');
    };
    mainBtn.addEventListener('click', openLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.closest('[data-lightbox-close]')) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  }

  /* ---- Reflect the selected store in the stock heading ---- */
  var storeLabel = root.querySelector('[data-stock-store]');
  if (storeLabel) {
    var stored = window.localStorage.getItem('mm_store');
    if (stored) storeLabel.textContent = stored;
    window.addEventListener('mm:storechange', function (e) {
      storeLabel.textContent = e.detail.store;
    });
  }
})();
